import {
  GET_REGISTRATION_REQUEST,
  GET_REGISTRATION_SUCCESS,
  GET_REGISTRATION_FAILURE,
  UPDATE_REGISTRATION_REQUEST,
  UPDATE_REGISTRATION_SUCCESS,
  UPDATE_REGISTRATION_FAILURE,
  AUTHORISATION_RETRY_REQUEST,
  AUTHORISATION_RETRY_SUCCESS,
  AUTHORISATION_RETRY_FAILURE,
  CLEAR_REGISTRATION,
} from "actions/registration";

const initialState = {
  loading: false,
  updating: false,
  error: null,
  registration: null,
};

export default function registration(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_REGISTRATION_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_REGISTRATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        registration: payload,
      };
    }

    case GET_REGISTRATION_FAILURE: {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    }

    case UPDATE_REGISTRATION_REQUEST:
    case AUTHORISATION_RETRY_REQUEST: {
      return {
        ...state,
        updating: true,
      };
    }

    case UPDATE_REGISTRATION_SUCCESS:
    case AUTHORISATION_RETRY_SUCCESS: {
      return {
        ...state,
        updating: false,
        error: null,
        registration: payload,
      };
    }

    case UPDATE_REGISTRATION_FAILURE:
    case AUTHORISATION_RETRY_FAILURE: {
      return {
        ...state,
        updating: false,
        error: payload,
      };
    }

    case CLEAR_REGISTRATION: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
}
